// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__3ros1","adornment":"Button_adornment__2CTqN","start":"Button_start__1fEA3","end":"Button_end__1AR2f"};